module.exports = __webpack_public_path__ + "static/4-3ac05084fed963e0f3e06c256f307cd4.jpg";